// components/Header.jsx
import React from 'react';
import "../componentCss/headForm.css";

const Header = ({ formList }) => {
    return (
      <div className="print-header">
        <table className="header-table">
          <tbody>
            <tr>
                <td className='logo-cell' rowSpan={4} width={33}>
                    <img
                    src="/assets/images/logo2.png"
                    alt="Neurula Logo"
                    className="logo-img"
                    />
                </td>
                <td width={33}>
                    <div><strong>NEURULA TECHNOLOGIES</strong></div>    
                </td>
                <td width={17}>
                    <div><strong>MRN:</strong></div>
                </td>
                <td width={17}>
                    <div>{formList?.mrnNumber || "NA"}</div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>BC05-08, AB Centre, Barsha 1, Dubai</div>
                </td>
                <td>
                    <div><strong>Patient Name:</strong></div>
                </td>
                <td>
                    <div>{formList?.[16] || "NA"} {formList?.[18] || "NA"}</div>
                </td>
            </tr>
            <tr>
                <td>
                <div>Phone: 80080050</div>
                </td>
                <td>
                <div><strong>Gender:</strong></div>
                </td>
                <td>
                <div>{formList?.[22] || "NA"}</div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Placeholder</div>
                </td>
                <td>
                    <div><strong>Age / DOB:</strong></div>
                </td>
                <td>
                    <div>{formList?.[21] || "NA"} / {formList?.[20] || "NA"}</div>
                </td>
            </tr>  
          
          </tbody>
        </table>
      </div>
    );
  };
  
  export default Header;